import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { type Settings } from '@/settings';

export default function (settings: Settings) {
  if (
    settings.SENTRY_DSN &&
    ['production', 'staging'].includes(import.meta.env.MODE)
  ) {
    Sentry.init({
      dsn: settings.SENTRY_DSN,
      environment: import.meta.env.MODE,
      /**
       * WORKAROUND CORS error:
       *
       * > Request header field baggage is not allowed by Access-Control-Allow-Headers in preflight response.
       *
       * > If you don't want to attach headers anywhere (i.e. turn off
       * > distributed tracing), you can just specify an empty array:
       * > tracePropagationTargets: [].
       * > https://github.com/getsentry/sentry-javascript/issues/6077#issuecomment-1322030967
       */
      tracePropagationTargets: [
        // /localhost:\d{4}/,
        // settings.BASE_API_ORIGIN + '/api',
      ],
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],

      /*
      Performance Monitoring

      Sample aggressively in production due to higher volume of interactions.
      We're setting these to 0 initially, making them a per-project opt-in
      config to avoid blowing our quota.
      */
      ...(import.meta.env.PROD
        ? {
            tracesSampleRate: 0.0,
            replaysOnErrorSampleRate: 0.0,
            // don't expend budget on non-error sessions
            replaysSessionSampleRate: 0.0,
          }
        : {
            tracesSampleRate: 0.0,
            replaysOnErrorSampleRate: 0.0,
            // don't expend budget on non-error sessions
            replaysSessionSampleRate: 0.0,
          }),
    });
  }
}
